/**
 * Prompt launch API (lot G step 20 — endpoint not yet deployed).
 * Stub: the CREATE and GET calls will use the real endpoint once lot G ships.
 * Used by lot B's LaunchDialog (agency only) in ship 4.
 */

import { api } from './api';

function uuidv4(): string {
  return globalThis.crypto.randomUUID();
}

// Stub types — replace with @traaker/shared imports once lot G step 20 ships
export interface PromptLaunchPreview {
  prompts: number;
  runs: number;
  credits: number;
  balance: number;
  inFlightRuns: number;
  replacesToday?: { axes: string[]; runs: number };
}

export interface PromptLaunchCreated {
  launchId: string;
  auditIds: string[];
}

export interface PromptLaunchAxisStatus {
  auditId: string;
  expected?: number;
  completedCount: number;
  ok: number;
  failed: number;
  finished: boolean;
  retrying: boolean;
}

export interface PromptLaunchStatus {
  status: 'open' | 'closed' | 'refused';
  refusedReason?: string;
  axes: Record<string, PromptLaunchAxisStatus>;
}

export type ManualLaunchMode = 'all' | 'missing';

export const promptLaunchesApi = {
  preview: (brandId: string, mode: ManualLaunchMode): Promise<PromptLaunchPreview> =>
    api.post(`/brands/${brandId}/prompt-launches/preview`, { mode }),

  create: (
    brandId: string,
    body: { mode: ManualLaunchMode; confirmReplace?: boolean },
    idempotencyKey: string = uuidv4(),
  ): Promise<PromptLaunchCreated> =>
    api.post(`/brands/${brandId}/prompt-launches`, body, { 'Idempotency-Key': idempotencyKey }),

  get: (brandId: string, launchId: string): Promise<PromptLaunchStatus> =>
    api.get(`/brands/${brandId}/prompt-launches/${launchId}`),
};
